(function (Drupal, $, window) {
  'use strict';

  Drupal.behaviors.homepageSlider = {
    attach: function (context, settings) {
      var $jq = jQuery.noConflict();
      $jq('.homepage-hero .home-slides').each(function () {
        let $homepageSlider = $jq(this);
        if (typeof $homepageSlider.slick !== 'undefined') {
          $homepageSlider.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 4000,
            vertical: true,
            rows: 0,
            appendDots: $homepageSlider.next('.paging').find('.dots'),
            prevArrow: $homepageSlider.next('.paging').find('.prev-slide'),
            nextArrow: $homepageSlider.next('.paging').find('.next-slide'),
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  adaptiveHeight: false,
                  vertical: false,
                }
              },
              {
                breakpoint: 768,
                settings: {
                  adaptiveHeight: true,
                  vertical: false,
                }
              }
            ]
          });
        }
      });
    }
  };
}(Drupal, jQuery, this));
